export default "__VITE_ASSET__SIfZ7ywe__"